// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CloseButton_closeButton__3iBWX"};